<header class="p-3 mb-3 border-bottom bg-white shadow-sm">
	<div class="container">
		<div class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
			<a href="/" class="d-flex align-items-center mb-2 mb-lg-0 link-body-emphasis text-decoration-none">
				<img src="https://kulaworkflowdev.softidoc.co.za/img/PandaHorizontalLogo.575d1c28.png"
					style="height: 2.5em;" />
			</a>
		</div>
	</div>
</header>

<div class="container mt-4">

	<!-- Loading spinner -->
	<div class="row justify-content-center" *ngIf="loading">
		<div class="col-auto text-center mt-5">
			<div class="spinner-border text-primary" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
			<p class="mt-3 text-muted">Fetching ticket status...</p>
		</div>
	</div>

	<!-- Error / Not Found -->
	<div class="row justify-content-center" *ngIf="!loading && error">
		<div class="col-md-6 col-10 text-center mt-5">
			<div class="alert alert-danger rounded-3 shadow-sm">
				<h5 class="mb-2">Ticket Not Found</h5>
				<p class="mb-0">{{error}}</p>
			</div>
		</div>
	</div>

	<!-- Ticket Details -->
	<div class="row justify-content-center" *ngIf="!loading && ticketStatus">
		<div class="col-md-8 col-lg-6 col-12">
			<div class="card shadow-sm border-0 rounded-4 p-4 text-center">
				<h5 class="text-muted mb-2">Ticket for</h5>
				<h4 class="fw-bold mb-3">{{ ticketStatus.memberName }}</h4>

				<div class="mb-4">
					<h6 class="text-secondary mb-1">Current Status</h6>
					<div
						class="badge bg-warning text-dark fs-6 px-3 py-2 rounded-pill text-capitalize">
						{{ ticketStatus.currentStatus }}
					</div>
				</div>

				<hr class="my-4" />

				<h6 class="text-secondary mb-3">Processing History</h6>

				<div class="timeline text-start">
					<div class="timeline-item mb-3" *ngFor="let update of ticketStatus.updates">
						<div class="d-flex">
							<div class="timeline-dot bg-success me-3 mt-1"></div>
							<div>
								<div class="fw-semibold">{{ update.name }}</div>
								<small class="text-muted">
									{{ update.when | date: 'yyyy-MM-dd HH:mm:ss' }}
								</small>
							</div>
						</div>
					</div>

					<div *ngIf="!ticketStatus.updates?.length" class="text-muted text-center mt-3">
						No updates yet.
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
